import React, { useContext } from 'react';
import proptypes from 'prop-types';
const { string } = proptypes;
import { ExperienceContext } from '@thd-nucleus/experience-context';
import classnames from 'classnames';
import './InformationalMessage.scss';

const InformationalMessage = ({ header, body }) => {

  const { channel } = useContext(ExperienceContext);
  const viewMode = classnames('', {
    'cpa-informational-message__info-mobile': channel === 'mobile',
    'cpa-informational-message__info': channel !== 'mobile'
  });

  return (
    <div>
      <div className="cpa-informational-message">
        <div>
          <p data-testid="cpa-info-paragraph" className={viewMode}>
            <img
              alt="tool tip info icon"
              className="cpa-informational-message__icon"
              src="https://assets.homedepot-static.com/images/v1/info.svg"
              height="17px"
              width="17px"
            />
            <span className="cpa-informational-message__header">
              { header }
            </span>
            <span className="cpa-informational-message__body">
              { body }
            </span>
          </p>
        </div>

      </div>
    </div>
  );
};

InformationalMessage.propTypes = {
  header: string.isRequired,
  body: string.isRequired
};

InformationalMessage.displayName = 'InformationalMessage';

export { InformationalMessage };
